var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "canvasContainer",
    staticClass: "m-image-marker-canvas",
    staticStyle: {
      "position": "relative",
      "display": "inline-block"
    }
  }, [_c('v-img', {
    key: _vm.src,
    ref: _vm.markerImage,
    class: _vm.imageClass,
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": _vm.markerImage,
      "src": _vm.src,
      "width": _vm.imageScaledDimensions.width,
      "height": _vm.imageScaledDimensions.height
    },
    on: {
      "load": _vm.onImageLoad,
      "mousedown": _vm.onMouseDown,
      "mouseup": _vm.onMouseUp,
      "mousemove": _vm.onMouseMove,
      "touchstart": _vm.onTouchStart,
      "touchend": _vm.onTouchEnd,
      "touchmove": _vm.onTouchMove
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex align-center justify-center fill-height",
          staticStyle: {
            "min-height": "30px"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "color": "grey-lighten-4",
            "indeterminate": ""
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('m-image-marker-magnifier', {
    ref: "magnifier",
    attrs: {
      "src": _vm.src,
      "imageDimensions": _vm.imageScaledDimensions,
      "deactivated": _vm.deactivated,
      "zoomFactor": _vm.magnificationFactor
    }
  }), _vm.imageLoaded ? _c('div', {
    ref: "imageOverlay",
    style: {
      position: 'relative',
      width: _vm.imageScaledDimensions.width + 'px',
      height: _vm.imageScaledDimensions.height + 'px'
    }
  }, _vm._l(_vm.markers, function (marker, idx) {
    return _c('m-image-marker-marker', {
      key: _vm.src + idx + (marker.color || ''),
      attrs: {
        "marker": marker,
        "containerWidth": _vm.imageScaledDimensions.width,
        "containerHeight": _vm.imageScaledDimensions.height,
        "size": _vm.markerSize,
        "deactivated": _vm.deactivated
      },
      on: {
        "mouseover": _vm.handleMarkerMouseOver,
        "hover": _vm.handleMarkerHover,
        "mouseleave": _vm.handleMarkerMouseLeave,
        "click": function click($event) {
          return _vm.$emit('markerClicked', $event);
        }
      }
    });
  }), 1) : _vm._e()], 1), _c('debug', {
    staticStyle: {
      "position": "absolute",
      "top": "0px"
    }
  }, [_vm._v(" height: " + _vm._s(_vm.imageScaledDimensions.height) + " "), _c('br'), _vm._v(" width: " + _vm._s(_vm.imageScaledDimensions.width) + " "), _c('br'), _vm._v(" max-width: " + _vm._s(_vm.containerWidth) + " "), _c('br'), _vm._v(" maxHeight: " + _vm._s(_vm.maxHeight) + " "), _c('br')])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }